import { render, staticRenderFns } from "./VenExL.vue?vue&type=template&id=5d835d45"
import script from "./VenExL.vue?vue&type=script&lang=js"
export * from "./VenExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports